module.exports = __webpack_public_path__ + "static/media/13-4.b1a09e3b.mp3";